import _ from 'lodash';
import { useEffect, useState } from 'react';

/**
 * Hook that returns the innerWidth and innerHeight of the browser window.
 *
 * Intended to be used as a helper in Storybook to set the `windowSize` Redux reducer.
 *
 * @return {{width: number, height: number}}
 */
const useWindowSize = () => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const setWindowSize = () => {
    if (typeof window === 'undefined') {
      return;
    }
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };
  const throttledSetWindowSize = _.debounce(setWindowSize, 100);

  useEffect(() => {
    setWindowSize();
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    window.addEventListener('resize', throttledSetWindowSize);

    return () => {
      window.removeEventListener('resize', throttledSetWindowSize);
    };
  }, []);

  return {
    width,
    height,
  };
};

export default useWindowSize;
